module.exports = __webpack_public_path__ + "static/media/alert-icon.795af910.svg";